import { useState, useMemo, useEffect } from "react";
import { Box, Card, Grid, Table, TableCell, TableContainer, TableHead, TableRow, TableBody } from "@mui/material"
import { SearchTextField } from "../lib"
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../context/message-context";
import { useTranslation } from "react-i18next";
import apiRequest from "../../functions/api";

function UserAuswahl({ client, accessToken, updateTitle, location }) {
  const [filter, setFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState([]);
  const { showErrorMessage } = useMessage();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const filteredUser = useMemo(() => {
    if (user && user.length > 0) {
      return user.filter(item => item.name.toLowerCase().includes(filter.toLowerCase()));
    } else {
      return user;
    }
  }, [user, filter]);

  useEffect(() => {
    updateTitle("Mitarbeiter Arbeitsunfähigkeit")
    setIsLoading(true);
    const payload = {
      "mandant": client, // this.props.client,
      "program": "SNDAUM",
      "statement": "UNTERGEORDNETE_USER_HOLEN",
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, userHolenCallback);
    // eslint-disable-next-line
  }, [])

  const userHolenCallback = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.user) {
        setUser(response.data.user);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }

  function onUserClick(userId) {
    navigate("/SNDAUM/SENDAU?userId=" + userId)
  }

  if (isLoading) {
    return <LoadingComponent path={location} />
  }

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item xs={12} md="6">
        <Card>
          <Box p={2}>
            <SearchTextField
              size="small"
              fullWidth
              label={t("Suche")}
              id="filter"
              variant="outlined"
              value={filter}
              inputProps={{
                autoCapitalize: 'off',
                autoCorrect: 'off',
                spellCheck: 'false',
                autoComplete: 'off'
              }}
              onChange={(e) => setFilter(e.target.value)}
            />
          </Box>
          <Box p={2}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow align="left" sx={{ display: { xs: 'none', lg: 'table' }, width: "100%" }}>
                    <TableCell width="20%" >{t("ID")}</TableCell>
                    <TableCell>{t("Name")}</TableCell>
                    <TableCell width="35%">{t("Aktion")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredUser && filteredUser.map(user => {
                    return (
                      <TableRow
                        key={user.id}
                        style={{ cursor: 'pointer' }}
                        onClick={() => onUserClick(user.id)}
                        hover
                      >
                        <Box sx={{ display: { xs: 'none', lg: 'table' }, width: "100%" }}>
                          <TableCell width="20%">{user.id}</TableCell>
                          <TableCell >{user.name}</TableCell>
                          <TableCell width="35%" >{t("Arbeitsunfähigkeit melden")}</TableCell>
                        </Box>
                        <Box sx={{ display: { lg: 'none', xs: 'table' }, width: "100%", }} >
                          <TableCell >
                            {user.id}<br />{user.name}<br />{t("Arbeitsunfähigkeit melden")}
                          </TableCell>
                        </Box>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Card>
      </Grid>
    </Grid>
  )
}

export default UserAuswahl;